<template>
    <div id="tabs_content">
        <popup v-show="hasPopup"
               :popup-type="getPopupType"
               :popup-action="getPopupAction"
               @popup-action="executePopupAction"></popup>
        <div class="inner_white">
            <div class="filter">
              <div class="field_left">
                <search-input input-class="search" v-model="formFields.search"></search-input>
              </div>
              <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset"
                :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
            </div>

            <div class="scroll-wrapper">
                <div class="table_overflow" id="contentBox" data-table-id="device-type-evaluations-list">
                    <table class="vypis vypis_detail">
                        <thead>
                        <tr v-if="entities.length > 0">
                            <th class="no_padding drag_drop"></th>
                            <th class="no_padding checkbox"/>
                            <sorting-table-title
                                v-for="title in tableTitles"
                                :key="title.key"
                                :column="title.column"
                                :sort="getActiveSort(title.column)"
                                @changeSorting="changeSorting"
                            >{{ title.name }}
                            </sorting-table-title>
                            <th class="no_padding edit"></th>
                        </tr>
                        </thead>

                        <device-type-evaluation-row
                            v-for="entity in entities"
                            :entity="entity"
                            :key="entity.id"
                            :selectedEntities="selectedEntities"
                            @input="select"
                            @deleteDeviceTypeEvaluation="deleteEntity"
                            :ref="'row-ref-' + entity.id"
                        ></device-type-evaluation-row>

                        <tr v-if="entities.length === 0">
                            <td colspan="7">{{ $gettext('Nebylo nalezeno žádné určení typu zařízení.') }}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <list-action-line
                :entities="entities"
                :offset="formFields.offset"
                :limit="formFields.limit"
                :total-count="totalCount"
                :selected-entities="selectedEntities"
                :multiple-action-options="multipleActionOptions"
                table-id="device-type-evaluations-list"
                @select-all="toggleSelectAll"
                @run-multiple-action="runMultipleAction"
                @limit="setLimit"
                @offset="setOffset"
                ref="action_line"
            ></list-action-line>
        </div>
    </div>
</template>

<script>
import DeviceTypeEvaluationRow from "@/components/views/deviceTypeEvaluations/DeviceTypeEvaluationRow"
import listActions from "@/components/mixins/list-actions"

export default {
    name: "DeviceTypeEvaluations",
    components: {
        DeviceTypeEvaluationRow,
    },
    mixins: [listActions],
    data() {
        return {
            moduleName: 'deviceTypeEvaluations',
            formFields: {
                sort: {
                    column: 'sName',
                    direction: 'asc',
                }
            }
        }
    },
    created(DeviceTypeEvaluationService) {
        this.entityService = DeviceTypeEvaluationService
        this.createdInit()
    },
    computed: {
        tableTitles() {
            return [
                {key: 1, name: this.$gettext('Název'), column: 'sName'},
                {key: 2, name: this.$gettext('Typ zařízení'), column: null},
                {key: 3, name: this.$gettext('Vytvořeno'), column: 'sDateCreated'},
                {key: 4, name: this.$gettext('Upraveno'), column: 'sDateUpdated'},
            ]
        },
        multipleActionOptions() {
            const options = [
                {value: 'choose', text: this.$gettext('Vyberte akci')},
            ]
            if (this.$_deleteActionAllowed) {
                options.push({value: 'delete', text: this.$gettext('Smazat')})
            }
            return options
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceTypeEvaluations/DeviceTypeEvaluationsList.vue